import {
	type LWApiPublicDomainListParamsRawI,
	type LWApiPublicDomainListResultRawI,
} from '@liquidweb-dev/club-sauce/public/domain/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import {
	useInfiniteQuery,
	useQuery,
	type UseQueryOptions,
} from '@tanstack/react-query';
import api from 'modules/queries/api';

export const DOMAIN_LIST_QUERY_KEY = '/domain/list';

const useDomainList = <TData = LWApiPublicDomainListResultRawI>(
	params: LWApiPublicDomainListParamsRawI,
	options?: UseQueryOptions<LWApiPublicDomainListResultRawI, ApiErrorI, TData>,
) =>
	useQuery({
		queryKey: [DOMAIN_LIST_QUERY_KEY, params],
		queryFn: () => api.domain.apiRaw.list(params),
		...options,
	});

export const useInfiniteDomainList = (
	params: Omit<LWApiPublicDomainListParamsRawI, 'page_num'>,
) =>
	useInfiniteQuery({
		queryKey: [DOMAIN_LIST_QUERY_KEY, params],
		queryFn: ({ pageParam }) =>
			api.domain.apiRaw.list({
				...params,
				page_num: pageParam || 1,
			}),
		getNextPageParam: (lastPage) => {
			const { page_num: lastPageNum, page_total: pageTotal } = lastPage;

			if (lastPageNum === pageTotal) return undefined;
			return lastPageNum + 1;
		},
	});

export default useDomainList;
